import { Inject, Injectable } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

import { ApiCommonService } from 'cbc-shared-lib';

import { FeaturesLibConfig } from '../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../config/features-lib-config.token';

import { SgKdConstants } from '../sg-kd-constants';

import {
  SZZA012AService,
  Szza012aRequest,
  Szza012aResponse
} from 'sg-api';

@Injectable({
  providedIn: 'root'
})
export class UsedSzza012aService {

  private _rsesult$ = new Subject<Szza012aResponse>();

  // get contractorValueChanges(): Observable<Szza012aResponse> {
  //   return this._rsesult$.asObservable();
  // }

  constructor(
    private szza012aService: SZZA012AService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
  ) { }

  /**
   * 業務日付取得
   *
   * @memberof UsedSzza012aService
   */
  doSzza012a(): Observable<Szza012aResponse> {

    // リクエスト情報生成
    let request: Szza012aRequest = {
      businessDayKbn: SgKdConstants.BUSINESS_DATE_KBN
    };

    return this.szza012aService.a10RSZZA012APost(this.apiCommonService.setRequestCommon(request), 'response')
      // NOTE:component側に戻り値として値を返却したい場合は、pipe(map())処理内で値を返却する。
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          this._rsesult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SZZA012A');
          return throwError(err.message);
        }
      )
    );
  }
}
